import { BREAKPOINTS } from "../styles/variables/breakpoints";

const tileData = [
  {
    section: "introduction",
    tiles: [
      {
        chunkIndex: 0,
        index: 1,
        customStyles: `
        position: absolute;
        right: 0;
        padding-top: 10rem;
        max-width: 40vw;
        z-index: -1;
         @media (max-width: ${BREAKPOINTS.sm}px) {
          position: relative;
          right: unset;
        }
        `,
      },
      {
        chunkIndex: 0,
        index: 2,
        customStyles: `
        bottom: 200px;
         @media (max-width: ${BREAKPOINTS.sm}px) {
          bottom: unset;
        }
        `,
      },
      {
        chunkIndex: 1,
        index: 0,
        customStyles: `
        padding-top: 10rem;
         @media (max-width: ${BREAKPOINTS.sm}px) {
         padding-top: 0;
        }
        `,
      },
      {
        chunkIndex: 1,
        index: 1,
        customStyles: `
        padding-top: 50vh;
         @media (max-width: ${BREAKPOINTS.sm}px) {
         padding-top: 0;
        }
        `,
      },
    ],
  },
  {
    section: "articles",
    tiles: [
      {
        chunkIndex: 0,
        index: 0,
        customStyles: `
        padding-top: 20vh;
         @media (max-width: ${BREAKPOINTS.sm}px) {
         padding-top: 0vh;
        }
        `,
      },
      {
        chunkIndex: 1,
        index: 0,
        customStyles: `
        padding-top: 45vh;
         @media (max-width: ${BREAKPOINTS.sm}px) {
         padding-top: 0vh;
        }
        `,
      },
      {
        chunkIndex: 1,
        index: 1,
        customStyles: `
        padding-top: 25vh;
         @media (max-width: ${BREAKPOINTS.sm}px) {
         padding-top: 0vh;
        }
        `,
      },
      {
        chunkIndex: 2,
        index: 0,
        customStyles: `
        padding-top: 45vh;
         @media (max-width: ${BREAKPOINTS.sm}px) {
         padding-top: 0vh;
        }
        `,
      },
      {
        chunkIndex: 2,
        index: 1,
        customStyles: `
        padding-top: 25vh;
         @media (max-width: ${BREAKPOINTS.sm}px) {
         padding-top: 0vh;
        }
        `,
      },
      {
        chunkIndex: 3,
        index: 0,
        customStyles: `
        padding-top: 45vh;
         @media (max-width: ${BREAKPOINTS.sm}px) {
         padding-top: 0vh;
        }
        `,
      },
      {
        chunkIndex: 3,
        index: 1,
        customStyles: `
        padding-top: 25vh;
         @media (max-width: ${BREAKPOINTS.sm}px) {
         padding-top: 0vh;
        }
        `,
      },
    ],
  },
  {
    section: "products",
    tiles: [
      {
        chunkIndex: 0,
        index: 0,
        customStyles: `
        position: absolute;
        left: 100px;
         @media (max-width: ${BREAKPOINTS.sm}px) {
         position: relative;
         left: unset;
        }
        `,
      },
      {
        chunkIndex: 0,
        index: 1,
        customStyles: `
        position: absolute;
        top: -200px;
        right: 40vh;
         @media (max-width: ${BREAKPOINTS.sm}px) {
         position: relative;
          top: unset;
          right: unset;
        }
        `,
      },
      {
        chunkIndex: 1,
        index: 0,
        customStyles: `
        position: absolute;
        left: 100px;
        bottom: -300px;
        z-index: 1;
         @media (max-width: ${BREAKPOINTS.sm}px) {
         position: relative;
         left: unset;
         bottom: unset;
         z-index: unset;
        }
        `,
      },
      {
        chunkIndex: 1,
        index: 2,
        customStyles: `
        bottom: -10px;
         @media (max-width: ${BREAKPOINTS.sm}px) {
         bottom: unset;
        }
        `,
      },
      {
        chunkIndex: 1,
        index: 2,
        customStyles: `
        bottom: 80px;
         @media (max-width: ${BREAKPOINTS.sm}px) {
         bottom: unset;
        }
        `,
      },
      {
        chunkIndex: 2,
        index: 0,
        customStyles: `
        right: 200px;
        top: 50px;
         @media (max-width: ${BREAKPOINTS.sm}px) {
         right: unset;
         top: unset;
        }
        `,
      },
      {
        chunkIndex: 0,
        index: 2,
        padding: `padding-top: 50%;`,
      },
    ],
  },
  {
    section: "stream",
    tiles: [
      {
        chunkIndex: 0,
        index: 1,
        customStyles: `
        padding-top: 25vh;
         @media (max-width: ${BREAKPOINTS.sm}px) {
         padding-top: 0;
        }
        `,
      },
      {
        chunkIndex: 1,
        index: 0,
        customStyles: `
        bottom: 150px;
        left: 80px;
         @media (max-width: ${BREAKPOINTS.sm}px) {
         bottom: unset;
         left: unset;
        }
        `,
      },
      {
        chunkIndex: 1,
        index: 1,
        customStyles: `
        padding: 0;

        @media (max-width: ${BREAKPOINTS.sm}px) {
        width: fit-content;
        margin: 0 auto;
        }
        `,
      },
      {
        chunkIndex: 2,
        index: 0,
        customStyles: `
        bottom: 180px;
        right: 100px;
        z-index: -1;
         @media (max-width: ${BREAKPOINTS.sm}px) {
         bottom: unset;
         right: unset;
         z-index: unset;
        }
        `,
      },
    ],
  },
];

export default tileData;
